export default "__VITE_ASSET__CsPkOHzh__"